var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpirationWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11328 3.8125C6.02734 3.8125 5.98438 3.87695 5.98438 3.96289L6.13477 8.17383C6.13477 8.23828 6.19922 8.28125 6.26367 8.28125H6.71484C6.7793 8.28125 6.84375 8.23828 6.84375 8.17383L6.99414 3.96289C6.99414 3.87695 6.95117 3.8125 6.86523 3.8125H6.11328ZM6.5 8.71094C6.15625 8.71094 5.89844 8.99023 5.89844 9.3125C5.89844 9.65625 6.15625 9.91406 6.5 9.91406C6.82227 9.91406 7.10156 9.65625 7.10156 9.3125C7.10156 8.99023 6.82227 8.71094 6.5 8.71094ZM12.5371 9.82812L7.38086 0.890625C6.99414 0.203125 5.98438 0.203125 5.59766 0.890625L0.441406 9.82812C0.0546875 10.5156 0.548828 11.375 1.34375 11.375H11.6562C12.4297 11.375 12.9453 10.5156 12.5371 9.82812ZM11.6562 10.6875H1.34375C1.06445 10.6875 0.914062 10.4082 1.04297 10.1719L6.19922 1.23438C6.32812 1.01953 6.65039 1.01953 6.7793 1.23438L11.9355 10.1719C12.0859 10.4082 11.9141 10.6875 11.6562 10.6875Z",
    fill: "#FF3333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpirationWarning);
export default __webpack_public_path__ + "static/media/ExpirationWarning.5e703e6aaad744a89672059a99938e3c.svg";
export { ForwardRef as ReactComponent };